import React, { useState, useCallback, useEffect } from 'react'
import { Row, Col, Layout, Modal } from 'antd'
import styled from 'styled-components'
import imagePlan from 'assets/img/plan.png'
import { AddIcon, CloseIcon } from 'Components/Shared/Icon'
import { Picker } from 'Components/Shared/Form'
import Editor from 'Components/Pages/ActivityDetailPage/Editor'
import file from 'utils/file'
import { LIMIT_FILE } from 'config'
import { translate } from 'i18n'
import TKeys from 'i18n/translationKey'
import imgPhoto from 'assets/img/ic-photo.png'
import { OutlineButton, PrimaryButton } from 'Components/Shared/Button'
import imgAddIcon from 'assets/img/ic_add_blue.png'

type Props = {
  onChange: (images: any) => void
  Image: any
  title?: string
  viewMode?: boolean
  onThumbnailOpen?: (image: any) => void
  onConfirmUploadFixImage?: (confirm: any) => void
  IsFixImageLost?: boolean
}

const ImgPicker: React.FunctionComponent<Props> = props => {
  const {
    onChange,
    Image,
    title = '',
    viewMode = false,
    onThumbnailOpen,
    onConfirmUploadFixImage,
    IsFixImageLost = false,
  } = props
  const [showEditor, setShowEditor] = useState(false)
  const [showError, setShowError] = useState(false)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [fileEditor, setFileEditor] = useState({
    base64: '',
    file: { name: '' },
    lastModified: 0,
  })
  const [visibleConfirm, setVisibleConfirm] = useState(false)

  const [showFixImageEditor, setShowFixImageEditor] = useState(false)
  const [fileFixImageEditor, setFileFixImageEditor] = useState({
    base64: '',
    file: { name: '' },
    lastModified: 0,
  })
  const [isFixImage, setIsFixImage] = useState(false)
  const [resetImage, setResetImage] = useState(Image)

  useEffect(() => {
    if (IsFixImageLost == true) {
      setIsFixImage(true)
    }
  }, [IsFixImageLost])
  const onResetImage = () => {
    setVisibleConfirm(false)
    onChange(resetImage)
  }

  const addFile = async (base64: any, fileItem: any) => {
    try {
      const lastModified = fileItem.lastModified
      setLoading(true)
      let resp
      if (fileItem.type === 'image/heic') {
        resp = await file.heicToJpeg({
          file: fileItem,
          filename: fileItem.name,
        })
        base64 = resp.text
        fileItem = resp.file
      }

      if (fileItem.size < LIMIT_FILE.image) {
        resp = await file.compress({
          value: base64,
          file: fileItem,
          limit: LIMIT_FILE.image,
        })
        base64 = resp.text
        fileItem = resp.file
      }

      setShowEditor(true)
      setFileEditor({ base64, file: fileItem, lastModified })
    } catch (e) {
      setError(translate(TKeys.Error.file_wrong))
      setShowError(true)
    }

    setLoading(false)
  }

  const onAddImage = async (base64: string) => {
    try {
      const params = {
        data: base64,
        filename: fileEditor.file.name,
        lastModified: fileEditor.lastModified,
      }
      const fileItem: any = await file.base64ToFile(params)
      const newImage = {
        text: base64,
        file: fileItem,
        lastModified: fileItem.lastModified,
      }

      onChange(newImage)
      setFileEditor({
        base64: '',
        file: { name: '' },
        lastModified: 0,
      })
    } catch (e) {
      setError(e.message)
      setShowError(true)
    }
    setShowEditor(false)
  }

  const fixFile = async (base64: any, fileItem: any) => {
    try {
      const lastModified = fileItem.lastModified
      let resp
      if (fileItem.type === 'image/heic') {
        resp = await file.heicToJpeg({
          file: fileItem,
          filename: fileItem.name,
        })
        base64 = resp.text
        fileItem = resp.file
      }

      if (fileItem.size < LIMIT_FILE.image) {
        resp = await file.compress({
          value: base64,
          file: fileItem,
          limit: LIMIT_FILE.image,
        })
        base64 = resp.text
        fileItem = resp.file
      }
      setResetImage(Image)
      setShowFixImageEditor(true)
      setFileFixImageEditor({ base64, file: fileItem, lastModified })
    } catch (e) {}
  }

  const fixImage = (
    <div>
      <Picker
        name={title}
        loading={false}
        text={'ADA'}
        accept=".png,.jpg,.heic"
        onChange={fixFile}
        customPickerBtn={
          <AddImage>
            <img src={imgAddIcon} alt="" width={20} height={20} />
          </AddImage>
        }
      />
    </div>
  )

  const onFixImage = async (base64: string) => {
    try {
      const params = {
        data: base64,
        filename: fileFixImageEditor.file.name,
        lastModified: fileFixImageEditor.lastModified,
      }
      const fileItem: any = await file.base64ToFile(params)
      const newImage = {
        text: base64,
        file: fileItem,
        lastModified: fileItem.lastModified,
      }
      onChange(newImage)
      setFileFixImageEditor({
        base64: '',
        file: { name: '' },
        lastModified: 0,
      })
      setVisibleConfirm(true)
    } catch (e) {}
    setShowFixImageEditor(false)
  }
  const onConfirmUpdateFixImage = () => {
    setVisibleConfirm(false)
    onConfirmUploadFixImage && onConfirmUploadFixImage(true)
  }

  const buttonAction = (
    <Row>
      <Col span={6} offset={6}>
        <OutlineButton
          text="ยกเลิก"
          disabled={false}
          onClick={() => onResetImage()}
        />
      </Col>
      <Col span={11} offset={1}>
        <PrimaryButton text="ยืนยัน" onClick={onConfirmUpdateFixImage} />
      </Col>
    </Row>
  )
  const addImage = (
    <Picker
      name={title}
      loading={false}
      disabled={false}
      text={'ADA'}
      accept=".png,.jpg,.heic"
      onChange={addFile}
      customPickerBtn={
        <AddImage>
          <AddIcon size={32} color="#8b99a7" />
          <div>คลิกเพื่อเพิ่มรูปภาพ</div>
        </AddImage>
      }
    />
  )

  const noneImage = (
    <ActionImage>
      <img src={imgPhoto} alt="" />
      <div>ไม่มีรูปภาพ</div>
    </ActionImage>
  )

  const emptyImage = !Image
  const imgContent = !emptyImage
    ? Image.FileID
      ? Image.FileURL
      : Image.text
    : ''

  return (
    <>
      <Editor
        visible={showEditor}
        image={fileEditor.base64}
        onClose={() => setShowEditor(false)}
        onOk={onAddImage}
      />
      <Editor
        visible={showFixImageEditor}
        image={fileFixImageEditor.base64}
        onClose={() => setShowFixImageEditor(false)}
        onOk={onFixImage}
      />
      <Modal
        centered
        visible={visibleConfirm}
        width="528px"
        footer={null}
        closeIcon={<CloseIcon color="#8b99a7" size={16} />}
        title={<Header>บันทึกรูป</Header>}
        className="add-checklist-modal"
        onCancel={() => onResetImage()}
      >
        <ModalContent>
          <span>ยืนยันต้องการบันทึกรูป</span>&nbsp;&nbsp;
          <ButtonSection>{buttonAction}</ButtonSection>
        </ModalContent>
      </Modal>
      <Box>
        <Header>
          <Row type="flex" justify="start">
            <Col>
              {title}
              &nbsp; &nbsp; &nbsp;
            </Col>

            {isFixImage && <Col>{fixImage}</Col>}
          </Row>
        </Header>
        <ImageBox
          style={{ backgroundImage: `url(${imgContent})` }}
          onClick={() => onThumbnailOpen && onThumbnailOpen(Image)}
        >
          {emptyImage && (viewMode ? noneImage : addImage)}
        </ImageBox>
      </Box>
    </>
  )
}

const Box = styled.div`
  padding: 15px;
  width: 100%;
`

const ImageBox = styled.div`
  margin-top: 10px;
  padding: 8px;
  height: 240px;
  border-radius: 3px;
  border: solid 1px #b9c6d3;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
`

const Header = styled.div`
  font-family: 'DB Helvethaica X 75 Bd';
  font-size: 20px;
`

const ActionImage: any = styled.div`
  font-family: 'DB Helvethaica X 55 Regular';
  color: #8b99a7;
  text-align: center;
  font-size: 20px;
  img {
    width: 28px;
    height: 27px;
    object-fit: contain;
    border: 0px;
    min-height: 27px;
    margin-bottom: 12px;
  }
`

const AddImage = styled(ActionImage)`
  cursor: pointer;
`

const ModalContent = styled.div`
  padding: 0 24px 31px 24px;
  font-family: 'DB Helvethaica X 55 Regular';
  font-size: 20px;
`
const ButtonSection = styled.div`
  margin-top: 32px;
  .btn-submit {
    width: 160px;
    margin-left: 16px;
  }
`
export default ImgPicker
